import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const PasswordInputWrapper = styled.div`
  position: relative;
  width: 580rem;

  ${respondTo.bigPhone`
    width: 100%;
    max-width: 100%;
  `}
`;

export const EyeWrapper = styled.div`
  user-select: none;
  position: absolute;
  top: 50%;
  right: 15rem;
  transform: translateY(-50%);
`;

export const ButtonContainer = styled.div`
  width: 100%;
`;

export const PasswordErrorMessage = styled.label`
  position: absolute;
  font-weight: 400;
  font-size: 12rem;
  color: ${COLORS.RED_100};
  bottom: -20rem;
  left: 0;
`;
